<template>
  <div class="sonar-alert-notification" role="alert">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'SonarAlertNotification',
  methods: {
    closeModal() {
      this.$emit('close-notification')
    },
  },
}
</script>

<style lang="scss">
$alert-right: -300px;
.sonar-alert-notification {
  &__wrapper {
    position: relative;
    width: 300px;
    height: 204px;
    padding: 20px 30px;
    position: fixed;
    top: 75px;
    right: 20px;
    z-index: 500;
    background: var(--glass-mid-gray) var(--black);
    border-radius: 10px;

    &::after {
      content: '';
      position: absolute;
      width: 0;
      height: 0;
      border-width: 10px;
      border-style: solid;
      border-color: #070709 transparent transparent transparent;
      top: 44px;
      background: transparent;
      top: -19px;
      right: 12px;
      transform: rotate(180deg);
    }
  }
  &__title {
    font-size: rem(24);
    line-height: rem(32);
    font-weight: 700;
    text-align: center;
    color: var(--white);
    margin: 0;
  }
  &__info {
    font-size: rem(16);
    line-height: rem(24);
    font-weight: 500;
    color: var(--light-blue-gray);
    text-align: center;
  }
  &__cta {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 10px;
    & button {
      padding: 8px 16px;
      height: 36px;
    }
  }
}
</style>
